import type {
	StaffAccessResponse,
	StaffAccount,
	StaffSessionResponse,
} from "@play/shared";
import ky from "ky";

import { getApiBaseUrl } from "@/shared/api/config";
import { describeApiError } from "@/shared/api/error-message";

export type {
	StaffAccessResponse,
	StaffAccount,
	StaffSessionResponse,
	StaffTag,
} from "@play/shared";

const staffHttp = ky.create({
	prefixUrl: getApiBaseUrl(),
});

export async function loginStaff(
	email: string,
	password: string,
): Promise<StaffSessionResponse> {
	return staffHttp
		.post("auth/staff/login", { json: { email, password } })
		.json();
}

export async function refreshStaffSession(
	refreshToken: string,
): Promise<StaffAccessResponse> {
	return staffHttp
		.post("auth/staff/refresh", { json: { refreshToken } })
		.json();
}

export async function logoutStaff(refreshToken: string): Promise<void> {
	await staffHttp.post("auth/staff/logout", { json: { refreshToken } });
}

export async function getStaffMe(accessToken: string): Promise<StaffAccount> {
	return staffHttp
		.get("auth/staff/me", {
			headers: { Authorization: `Bearer ${accessToken}` },
		})
		.json();
}

export async function readStaffLoginError(error: unknown): Promise<string> {
	return describeApiError(error);
}
